import React, { useState, useEffect } from 'react'
import { connectRange } from 'react-instantsearch-dom'
import Rheostat from 'rheostat'
import numeral from 'numeral'

import 'rheostat/initialize'

import RheostatContainer from '../../atoms/RheostatContainer'
import PriceRangeValue from '../../atoms/Search/PriceRangeValue'

const PriceRangeSlider = ({ currentRefinement, min, max, refine }) => {
  const [values, setValues] = useState()

  useEffect(() => {
    setValues([currentRefinement.min, currentRefinement.max])
  }, [currentRefinement.min, currentRefinement.max])

  return (
    <RheostatContainer>
      <Rheostat
        values={values}
        min={min}
        max={max}
        onValuesUpdated={({ values: [min, max] }) => setValues([min, max])}
        onChange={({ values: [min, max] }) => refine({ min, max })}
      />
      {(values || []).map((value, i) => (
        <PriceRangeValue key={i} className='Values'>
          {numeral(value).format('$0,0')}
        </PriceRangeValue>
      ))}
    </RheostatContainer>
  )
}

export default connectRange(PriceRangeSlider)
